import { DataFormatter } from '@farris/ui-common/column';

/** æ¶èåå­æ®µåç§° */
export const FAVORITE_FIELD_NAME = '__favorite__';
export const INPUT_GROUP_ICON = '<i class="f-icon f-icon-lookup"></i>';

// è·åç»ä»¶å®ä¾çç±»å
export type ComponentInstanceType = 'datatable'| 'treetable' | 'fav' | 'selected' | 'leftTree' | 'leftDataTable';

export enum LookupGridDisplayType {
    List = 'LIST',
    TreeList = 'TREELIST',
    NavList = 'NAVLIST',
    NavTreeList = 'NAVTREELIST',
    NavListTree = 'NAVLISTTREE'
}

/** æ¶èç¸å³å¾æ  */
export enum FavoriteIcon {
    /** å·²æ¶è */
    yes = '<span class="f-icon f-icon-star f-lookup-favorite" style="font-size:12px" ></span>',
    /** æªæ¶è */
    no = '<span class="f-icon f-icon-star-outline f-lookup-favorite" style="font-size:12px"></span>',
    /** ç§»é¤æ¶è */
    delete = '<span class="f-icon f-icon-star f-lookup-unfavorite" style="font-size:12px"></span>',
    /** ç§»é¤å·²éè®°å½ */
    remove = '<span class="f-icon f-icon-minus-circle" style="font-size:12px; color: #dd2438;cursor: pointer"></span>'
}

/** æ¶èç¸å³å¨ä½ */
export enum FavoriteAction {
    /** æ·»å æ¶è */
    add = 'append item to favorite.',
    /** ç§»é¤æ¶è */
    delete = 'remove favorite.'
}

export interface ExtInfoFormatterParam {
    [key: string]: any;
    bindingData?: any;
    instance?: any;
}

export type ExtInfoFormatterFn = (param: ExtInfoFormatterParam) => string;
export type ExtInfoFormatter = string | ExtInfoFormatterFn;

export interface CustomDataFormatter {
    /** æ°æ®æ ¼å¼å */
    [fieldName: string]: DataFormatter ;
    /** è¡æ ·å¼ */
    rowStyler?: (e: { data: any }) => {[key: string]: any};
    /** ååæ ¼æ ·å¼ */
    cellStyler?: (e: { data: any }, field: string) => {[key: string]: any};
}

export interface QuickSelectOption {
    /** æ¯å¦å¯ç¨ */
    enable?: boolean;
    /** æ¾ç¤ºtop è®°å½æ°ï¼é»è®¤ 10 */
    showItemsCount?: number;
    /** æ¾ç¤ºææ¬å­æ®µ */
    textField?: string;
    /** èªå®ä¹æ ¼å¼å */
    formatter?: (data: any) => string;
    
    footerHeight?: number;
    /** æ¾ç¤ºæç´¢æ´å¤ æé® */
    showMore?: boolean;
    /** æå°å®½åº¦, é»è®¤ 200px */
    minWidth?: number;
    /** å¯ç¨åéé®ç§»é¤éä¸­é¡¹ï¼é»è®¤ä¸º false */
    enableBackspace?: boolean;
}

export const QuickSelectDefaultOptions: QuickSelectOption = {
    enable: false,
    showMore: true,
    showItemsCount: 10,
    footerHeight: 0,
    minWidth: 200,
    enableBackspace: false
}

/**
 * - both: å¨é¨æ¾ç¤º
 * - onlyfield: ä»æ¾ç¤ºå­æ®µ
 * - onlyinput: ä»æ¾ç¤ºæç´¢è¾å¥æ¡ */
export enum SearchBarMode {
    /** æ¾ç¤ºå­æ®µæ¥è¯¢ä¸æç´¢è¾å¥æ¡ */
    both = 'both',
    /** ä»æ¾ç¤ºå­æ®µ */
    onlyinput = 'onlyinput',
    /** ä»æ¾ç¤ºæç´¢è¾å¥æ¡ */
    onlyfield = 'onlyfield'
}